<div class="layout-container">
  <ng-content />
</div>
